import { render, staticRenderFns } from "./archivedTaskList.vue?vue&type=template&id=a072fe2c&"
import script from "./archivedTaskList.vue?vue&type=script&lang=js&"
export * from "./archivedTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports